import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[tooltip]',
  standalone: true
})
export class TooltipDirective {
  @Input() tooltip = ''; // The text for the tooltip to display
  @Input() delay? = 190; // Optional delay input, in ms
  constructor(private el: ElementRef) { }

  private myPopup:any ;
  private timer:any ;

  @HostListener('mouseenter') onMouseEnter() {
    this.timer = setTimeout(() => {
      this.createTooltipPopup();
    }, this.delay)
  }
  @HostListener('mouseleave') onMouseLeave() {
    if (this.timer) clearTimeout(this.timer);
    if (this.myPopup) { this.myPopup.remove() }
  }

  private createTooltipPopup() {
    let popup = document.createElement('div');
    popup.innerHTML = this.tooltip;
    popup.setAttribute("class", "tooltip-container");
    popup.style.visibility = "hidden"; // erst unsichtbar rendern, um Höhe zu ermitteln
    document.body.appendChild(popup);
    this.myPopup = popup;

    const targetRect = this.el.nativeElement.getBoundingClientRect();
    const popupHeight = popup.offsetHeight;

    let x = targetRect.left + this.el.nativeElement.offsetWidth / 2; // Get the middle of the element
    let y = targetRect.top + this.el.nativeElement.offsetHeight + 6; // Get the bottom of the element, plus a little extra

    // Falls der Tooltip unterhalb nicht mehr in den sichtbaren Bereich passt,
    // wird er stattdessen oberhalb des Elements angezeigt
    if (y + popupHeight > window.innerHeight) {
      y = targetRect.top - popupHeight - 6;
    }

    popup.style.top = y.toString() + "px";
    popup.style.left = x.toString() + "px";
    popup.style.visibility = "visible";

    setTimeout(() => {
      if (this.myPopup) this.myPopup.remove();
    }, 5000); // Remove tooltip after 5 seconds
  }
}